import { render, staticRenderFns } from "./container-tab.vue?vue&type=template&id=a67b7cf8&scoped=true&"
import script from "./container-tab.vue?vue&type=script&lang=js&"
export * from "./container-tab.vue?vue&type=script&lang=js&"
import style0 from "./container-tab.vue?vue&type=style&index=0&id=a67b7cf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b7cf8",
  null
  
)

export default component.exports